import React from "react";

import { DropdownMenuItem } from "src/app/components/Dropdown/Dropdown";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as InfoGreyIcon } from "src/images/info-grey.svg";

export default function ShowDetailsMenuItem({
  handleClick,
}: {
  handleClick: () => void;
}) {
  return (
    <DropdownMenuItem onClick={handleClick}>
      <InfoGreyIcon />
      <IDHFormattedMessage id="ws_show_details" defaultMessage="Show details" />
    </DropdownMenuItem>
  );
}
